import React from "react";
import { Overlay, Wrapper, Header, InnerWrapper } from "./styled";
import types from "./types";
import { injectIntl } from "react-intl";

const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

const SettingsModal = (props) => {
  const Settings = types[props.type];

  const headerTitle = {
    col: `${props.intl.formatMessage({ id: "SettingsModal.column" })} ${
      alphabet[props.colIdx]
    }`,
    cell: `Cell ${alphabet[props.cellIdx]}${props.rowIdx + 1}`,
  }[props.type];

  return (
    <Overlay>
      <Wrapper>
        <Header>{headerTitle}</Header>
        <InnerWrapper>
          <Settings {...props} />
        </InnerWrapper>
      </Wrapper>
    </Overlay>
  );
};

export default injectIntl(SettingsModal);
